import React from 'react';
import { Chip } from '@mui/material';
import { ExternalLeadQuality } from '@tassomutuo-backoffice/types';

interface IProps {
  quality?: ExternalLeadQuality;
}

const ExternalLeadQualityChip = ({ quality }: IProps) => {
  if (!quality) return null;

  const color: 'success' | 'error' | 'default' =
    quality === 'good' ? 'success' : quality === 'low' ? 'error' : 'default';
  const label = quality === 'good' ? 'Qualità OK' : quality === 'low' ? 'Bassa qualità' : quality;

  return <Chip size="small" label={label} color={color} />;
};

export default ExternalLeadQualityChip;
